import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  listaNotificacoes: function () {
    return Vue.http.get('/api/notificacao/listanotificacoes').then(response => response.body);
  }, 
  listaNotificacoesSolicitacoes: function () {
    return Vue.http.post('/api/liberarsolicitacao').then(response => response.data);
  },
  contagemSolicitacoesLiberacao: function () {
    return Vue.http.get('/api/liberarsolicitacao/contagem').then(response => response.body);
  },
  listaPedidosNaoLiberados: function () {
    return Vue.http.get('/api/pedido/listapedidosnaoliberados').then(response => response.body);
  }, 
  listaPesquisasNaoAprovadas: function () {
    return Vue.http.get('/api/pesquisapreco/listapesquisasnaoaprovadas').then(response => response.body);
  },
  listaPesquisasPassagemNaoAprovadas: function () {
    return Vue.http.get('/api/pesquisapassagem/listapesquisasnaoaprovadas').then(response => response.body);
  },
  listaProjetosTerminando: function () {
    return Vue.http.get('/api/projetos/ProjetosTerminandoNotificacao').then(response => response.body);
  },
  listaPendencias: function () {
    return Vue.http.get('/api/notificacao/pendencias').then(response => response.body);
  },
  listaPendenciasDiarias: function () {
    return Vue.http.get('/api/notificacao/pendencias/diarias').then(response => response.body);
  },
  listaPendenciasPagamentos: function () {
    return Vue.http.get('/api/notificacao/pendencias/pagamentos').then(response => response.body);
  },
  listaPendenciasProvisoes: function () {
    return Vue.http.get('/api/notificacao/pendencias/provisoes').then(response => response.body);
  },
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/notificacoes/servico.js